var _rect, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCompletionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 78,
    viewBox: "0 0 160 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 78,
    fill: "#E5F2FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 28.5,
    r: 28.5,
    fill: "#CEE7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 56.5,
    r: 21.5,
    fill: "#CEE7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9996 13.0014C64.9996 6.83478 59.5249 3.7713 46.9996 13.0014C18.5 34.0033 25.0001 3.49778 12.0001 4.49778C-0.999937 5.49778 17.3268 42.0121 40 34.001C48.5005 30.9976 35 17 30.4996 42.0011",
    stroke: "#1549B0",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115 19.4908C109.5 28.9998 95 9.00024 93.5 16.5C91.159 28.2044 124.5 60.4927 76 31.4908",
    stroke: "#1549B0",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140 30.5C134.5 34.3333 126.8 43.1 140 47.5C156.5 53 147.5 57 132.5 58C117.5 59 105.5 46 97.5 60.5C89.5 75 86.5 47 75 51C63.5 55 75.5 62.5 54 58",
    stroke: "#1549B0",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21.3334C84.0046 23.0932 83.5934 24.8292 82.8 26.4C81.8592 28.2824 80.413 29.8656 78.6233 30.9724C76.8335 32.0792 74.771 32.6659 72.6667 32.6667C70.9068 32.6713 69.1708 32.2601 67.6 31.4667L60 34L62.5333 26.4C61.7399 24.8292 61.3287 23.0932 61.3333 21.3334C61.3341 19.229 61.9208 17.1665 63.0276 15.3768C64.1344 13.587 65.7177 12.1408 67.6 11.2C69.1708 10.4066 70.9068 9.99545 72.6667 10H73.3333C76.1125 10.1534 78.7374 11.3264 80.7055 13.2945C82.6737 15.2626 83.8467 17.8876 84 20.6667V21.3334Z",
    fill: "white",
    stroke: "#77AAF1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6605 17.2727H70.2727L72.4886 22.6761H72.5909L74.8068 17.2727H77.419V26H75.3651V20.6392H75.2926L73.196 25.9446H71.8835L69.7869 20.6094H69.7145V26H67.6605V17.2727Z",
    fill: "#1549B0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4673 8.78174V9.49381",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7285 10.5347H66.824",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2622 8.34362C67.2622 7.73515 66.9336 7.18415 66.9336 6.59082",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1011 32.5391H79.9372",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9512 33.4946V35.5252",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3843 34.3306C78.5973 34.3542 78.6826 34.509 78.7426 34.6889",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136 57.3334C136.005 59.0932 135.593 60.8292 134.8 62.4C133.859 64.2824 132.413 65.8656 130.623 66.9724C128.834 68.0792 126.771 68.6659 124.667 68.6667C122.907 68.6713 121.171 68.2601 119.6 67.4667L112 70L114.533 62.4C113.74 60.8292 113.329 59.0932 113.333 57.3334C113.334 55.229 113.921 53.1665 115.028 51.3768C116.134 49.587 117.718 48.1408 119.6 47.2C121.171 46.4066 122.907 45.9954 124.667 46H125.333C128.112 46.1534 130.737 47.3264 132.706 49.2945C134.674 51.2626 135.847 53.8876 136 56.6667V57.3334Z",
    fill: "white",
    stroke: "#77AAF1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.661 53.2727H122.273L124.489 58.6761H124.591L126.807 53.2727H129.419V62H127.365V56.6392H127.293L125.196 61.9446H123.884L121.787 56.6094H121.714V62H119.661V53.2727Z",
    fill: "#1549B0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117.174,
    y: 10.3193,
    width: 33,
    height: 20,
    transform: "rotate(-5.06689 117.174 10.3193)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.915,
    y: 43,
    width: 33,
    height: 20,
    transform: "rotate(3.78421 19.915 43)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 117.174,
    y: 10.3193,
    width: 6,
    height: 20,
    transform: "rotate(-5.06689 117.174 10.3193)",
    fill: "#AAD4FB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 28.5303,
    width: 10.6506,
    height: 4.42767,
    transform: "rotate(-5.06689 134 28.5303)",
    fill: "#AAD4FB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.915,
    y: 43,
    width: 32.9387,
    height: 3.8472,
    transform: "rotate(3.78421 19.915 43)",
    fill: "#AAD4FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.458,
    y: 54,
    width: 3.31331,
    height: 6.93735,
    transform: "rotate(3.78421 52.458 54)",
    fill: "#AAD4FB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 113.719,
    y: 16.6494,
    width: 4,
    height: 8,
    transform: "rotate(-5.06689 113.719 16.6494)",
    fill: "#AAD4FB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24.2949,
    y: 40,
    width: 10.657,
    height: 4.46569,
    transform: "rotate(3.78421 24.2949 40)",
    fill: "#AAD4FB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.608 14.4151C126.261 14.4151 127.143 14.5806 127.623 14.0332C128.049 13.5485 128.283 12.7949 128.056 12.1687C127.936 11.8365 127.474 11.583 127.123 11.713C126.85 11.8139 126.928 12.506 127.02 12.6822C127.529 13.659 129.177 13.4391 130.027 13.2502C131.064 13.0197 132.223 12.6562 132.966 11.8478C133.333 11.4491 132.943 11.2818 132.524 11.2445C131.999 11.1979 131.813 11.2956 131.705 11.8189C131.538 12.6304 132.146 13.0069 132.867 13.1892C134.491 13.6 136.571 13.1832 137.944 12.2072C138.407 11.8775 138.333 11.1241 138.027 10.699C137.719 10.2712 137.44 10.6066 137.276 10.9525C137.164 11.1886 136.811 11.8707 137.058 12.1174C137.303 12.3624 137.693 12.3909 138.017 12.419C138.859 12.4917 139.777 12.516 140.614 12.3998C142.302 12.165 143.824 11.2454 145.106 10.1662C145.375 9.94 145.839 9.70934 145.998 9.38965",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.955 18.1124C129.925 18.1124 133.899 17.9143 137.867 17.8043C138.388 17.7898 139.159 17.8891 139.702 17.708",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.918 23.08C130.881 23.08 133.846 23.1173 136.808 23.0671C138.142 23.0445 139.469 22.9541 140.797 22.8233C140.981 22.8051 141.221 22.838 141.377 22.7334",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M146.865 16.3793C146.294 16.3793 145.711 16.353 145.248 16.7387C144.662 17.2265 144.277 17.8996 144.15 18.6449C143.988 19.5971 143.979 20.7354 144.542 21.5523C145.202 22.5112 146.467 22.4895 147.533 22.3482C148.537 22.2151 150.026 21.6017 150.501 20.6217C150.788 20.0304 150.778 18.9967 150.498 18.4042C150.16 17.6918 149.304 17.2227 148.595 16.9569C148.071 16.7605 147.201 16.5516 146.683 16.3789",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.287 17.9968C145.923 17.6726 145.456 18.7909 145.549 19.1072C145.729 19.7152 147.062 19.7058 147.443 19.3254C147.546 19.2221 147.5 18.9956 147.5 18.8601C147.5 18.5738 147.47 18.5065 147.34 18.2857C147.232 18.1029 146.681 17.9968 146.461 17.9968",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.981 19.6719C146.356 19.6719 146.079 20.332 145.796 20.7405C145.534 21.1191 145.421 21.7056 145.421 22.1557",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.98 19.7877C147.438 19.7877 147.962 19.7125 148.412 19.8006C148.664 19.8499 149.197 20.1314 149.291 20.3911C149.348 20.5464 149.487 20.7054 149.551 20.8853C149.608 21.0439 149.58 21.238 149.58 21.4051",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 52.4312C22.5622 52.4312 24.2776 52.488 25.7279 51.6178C26.6299 51.0766 27.1777 49.9637 26.8839 48.9146C26.7696 48.5062 25.6737 48.1967 25.3921 48.5408C25.0363 48.9757 24.924 49.9044 25.1464 50.4098C25.3629 50.902 25.9821 51.2613 26.4616 51.4482C27.4923 51.85 28.6017 51.8303 29.691 51.8047C30.626 51.7827 31.5134 51.4707 32.3734 51.1229C32.5426 51.0544 32.8995 50.9528 32.8995 50.7179C32.8995 50.1311 32.3544 49.7143 31.8404 49.5376C31.561 49.4416 31.2787 49.3665 30.982 49.3784C30.8312 49.3844 30.724 49.8572 30.6878 49.9737C30.6011 50.2532 30.511 50.6867 30.6359 50.9706C30.8847 51.5361 31.6724 52.0467 32.2142 52.2789C33.2506 52.7231 34.3706 52.7925 35.4816 52.8327C36.7321 52.8779 37.8324 52.2227 38.9013 51.649C39.4772 51.3398 40.1783 50.956 39.6282 50.2645C39.383 49.9562 39.142 49.8768 38.756 49.8768C38.5365 49.8768 37.9998 49.7707 37.8214 49.9391C37.4737 50.2675 37.5606 51.0524 37.5722 51.469C37.5829 51.8533 38.1119 52.2435 38.3787 52.4554C39.0012 52.9498 39.9319 52.805 40.6735 52.805C42.1892 52.805 43.6151 52.5203 45.0969 52.2166C45.8332 52.0657 46.6578 51.822 47.416 51.8082C48.0384 51.7969 48.489 52.2004 48.9943 52.5177C49.1879 52.6393 49.5343 52.7877 49.5343 53.0542",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2432 55.4844H38.5072",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5576 59.6582H33.0867",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4974 56.419C41.4974 58.0915 41.4354 59.7788 41.4974 61.4516C41.506 61.686 42.1842 61.6476 42.3454 61.687C43.2389 61.9054 44.1653 61.9158 45.0763 62.0262C45.5601 62.0848 46.0561 62.1508 46.5439 62.1508C46.7164 62.1508 46.8866 62.1229 46.9661 61.9639C47.2803 61.3356 47.5407 60.9334 47.5407 60.2125C47.5407 59.2018 47.5407 58.1911 47.5407 57.1805C47.5407 57.0624 47.6858 55.8953 47.5684 55.8617C47.0117 55.7027 46.145 55.706 45.5609 55.8098C44.8053 55.9441 44.0234 55.8633 43.2695 56.014C42.7891 56.1101 42.1777 56.1075 41.6843 56.1075C41.1813 56.1075 41.6227 56.5901 41.7154 56.7963C41.9186 57.2477 42.1523 57.6145 42.4942 57.9765C43.1178 58.6368 44.4806 58.6898 45.1732 58.1012C45.413 57.8973 45.7211 57.8024 45.952 57.5716C46.1947 57.3289 46.3706 57.0062 46.6373 56.7928C46.8314 56.6376 47.2915 56.323 47.2915 56.0452",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2422 59.9072H45.8589",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3284 53.9559C52.3284 54.7597 52.3314 55.5637 52.3284 56.3676C52.3268 56.8056 52.2634 57.2352 52.2354 57.6713C52.2104 58.062 52.1867 58.4526 52.1755 58.8441C52.1636 59.2602 52.1245 59.6763 52.0544 60.0867C52.0292 60.2347 52.0259 60.379 52.019 60.5282C52.0135 60.6469 52.0272 60.8246 51.9811 60.9342C51.9102 61.1025 52.0513 61.013 52.1547 61.0052C52.9032 60.9481 53.6584 61.0443 54.4075 61.0443C54.6637 61.0443 54.9243 61.0682 55.1792 61.0871C55.2701 61.0938 55.3632 61.0883 55.4543 61.0883C55.5034 61.0883 55.5681 61.1356 55.5644 61.0663C55.5627 61.0336 55.5431 61.0071 55.5326 60.977C55.5032 60.893 55.5067 60.7866 55.4984 60.6994C55.4627 60.3269 55.47 59.9523 55.4495 59.5792C55.41 58.8635 55.4213 58.1373 55.4336 57.4206C55.4453 56.7352 55.5557 56.0163 55.6867 55.3427C55.7419 55.059 55.8048 54.7753 55.8457 54.4891C55.8552 54.4229 55.8934 54.1185 55.8457 54.0708C55.834 54.0591 55.7948 54.0659 55.7809 54.0659C55.6832 54.0659 55.5894 54.0429 55.4935 54.0268C55.1266 53.9652 54.7588 53.9243 54.3879 53.9008C53.9511 53.8732 53.5139 53.9087 53.0781 53.8568C52.8622 53.8311 52.6483 53.8238 52.4311 53.8238C52.3807 53.8238 52.1998 53.8528 52.1743 53.8018",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0771 56.0254H53.9797",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0332 57.0381H54.1779",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4736 59.1074H54.7504",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5269 60.14C56.5694 59.8 58.3993 60.2907 58.6175 60.5089",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2808 61.4316C56.3793 61.444 56.483 61.6392 56.5404 61.7049C56.9093 62.1274 57.2982 62.5309 57.6575 62.9621C58.125 63.5231 58.5505 64.04 58.7404 64.7521",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8662 62.292V64.1367",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5141 41.29C26.5141 41.7138 26.4215 42.287 26.605 42.6541",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9697 41.29V43.0179",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9697 41.8359V43.0182",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38C24.9708 37.7413 24.5468 37.4686 24.3405 37.3143C24.0907 37.1274 23.8713 36.8965 23.6452 36.6857C23.4678 36.5203 23.2107 36.0933 23 36",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39C22.5041 38.6788 22.0733 38.1476 21.6667 37.7121C21.0337 37.0343 20.4355 36.3726 19.9513 35.5614C19.6554 35.0658 19.3884 34.4193 19 34",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22 40C21.0905 40 20.1633 40 19.2579 40C18.8091 40 18.3813 40 18 40",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M133.935 33.2174C133.862 33.1518 133.722 33.2501 133.655 33.2833C133.302 33.4572 132.957 33.7029 132.654 33.9532C132.406 34.1575 132.179 34.4793 131.874 34.6011",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M134.189 34.0088V34.9124",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M133.879 32.2856C133.862 32.218 133.546 32.2572 133.496 32.2558C133.25 32.2493 133.034 32.2019 132.806 32.1162",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M136.562 29.3486C136.562 30.2379 136.563 31.0997 136.731 31.9749",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M139.498 29.603C139.498 29.3822 139.5 30.045 139.517 30.2651C139.556 30.768 139.671 31.258 139.78 31.7492",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M142.576 29.5754C142.576 28.8223 142.576 31.0815 142.576 31.8345",
    stroke: "black",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCompletionImg);
export default __webpack_public_path__ + "static/media/profile-completion-img.ca2d0bf8829b468480ad2fa2aed69cd1.svg";
export { ForwardRef as ReactComponent };